import React from 'react';

import { DateTimeInputContainer } from './styles';
import { doesCountryUse12HoursFormat } from '../../../constants/location';
import { DateTimePicker as MuiDateTimePicker } from '../../DateTimePickers/DateTimePickers';

function FilterDateTimeInput(props) {
  const { containerProps = {}, ...rest } = props;
  const is12HoursFormat = doesCountryUse12HoursFormat();
  const timeFormat = is12HoursFormat ? 'hh:mm A' : 'HH:mm';

  return (
    <DateTimeInputContainer {...containerProps}>
      <MuiDateTimePicker {...rest} inputVariant="standard" format={`MMMM D, YYYY ${timeFormat}`} />
    </DateTimeInputContainer>
  );
}

export default FilterDateTimeInput;
